import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederNordenDto from '../Models/VeilederNordenDto';
import { VeilederNordenAppState } from '../Store';
import { connect } from 'react-redux';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { StamdataNordenHelgradModel } from '../Models/StamdataNordenHelgradModel';
import * as ValgTypes from '../Store/Valg/Types';
import { formatNumber, hentAntallDagerDetSkalRegnesStipendOgLanFor } from '../Utilities/Helpers';
import BetaleTypeValg from '../Utilities/BetaleTypeValg';
import { tilPengerFormat} from '../../Shared/Scripts/Utilities/Formatters';

interface UtbetalingOwnProps {
    satser: StamdataNordenHelgradModel | null,
    valg: ValgTypes.ValgState,
    locale: string,
    valuta: string,
}

type UtbetalingProps = UtbetalingOwnProps & MapStateToProps & {};

const UtbetalingDetaljerComponent = (props: UtbetalingProps): JSX.Element => {
    const { epiContext } = props;
  
    function hentBasisLan() {
        if(props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG !== undefined)
            return props.satser?.SATS_ST01_MAKS_BASISSTOTTE_DAG * hentAntallDagerDetSkalRegnesStipendOgLanFor(props.valg.aVarighet?.value);

        return 0;
    }

    return (
        <div>
            <h4>{contentResolver(epiContext, 'betPlanTittelYtelser')}</h4>
            <div role="table" className="c-table">
                <div role="row" className="c-table__header-row">
                    <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                        {contentResolver(epiContext, 'betPlanTittelYtelseKolonne')}
                    </div>
                    <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                        {contentResolver(epiContext, 'betPlanTittelBelopKolonne')}
                    </div>
                </div>
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'betPlanDetaljerBasisLan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {tilPengerFormat(hentBasisLan(), props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                {props.valg.bBetale?.value === BetaleTypeValg.a1_ja && (
                    <div role="row" className="c-table__data-row">
                        <div role="cell" className="c-table__data-cell">
                            {contentResolver(epiContext, 'betPlanDetaljerSkolepengeLan')}
                        </div>
                        <div role="cell" className="c-table__data-cell">
                            {formatNumber(props.valg.cSkolepengerBelop, props.locale)}
                            &nbsp;{props.valuta}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederNordenDto>;
}

export default connect(
    (state: VeilederNordenAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(UtbetalingDetaljerComponent);